import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

const prefix = '/api/v1/corrections';

export const fetchCorrections = (book, params = {}) => {
    return axios.get(prefix + '/', {
        params: {
            book,
            ...params
        }
    });
};

export const fetchCorrectionThread = (id, params = {}) => {
    return axios.get(prefix + '/thread/', {
        params: {
            thread: id,
            ...params
        }
    });
};

export const fetchCorrectionsStates = () => {
    return axios.get(prefix + '/states/');
};

export const fetchCorrection = async (id, params = {}) => {
    const { results } = await axios.get(prefix + `/`, { params: { id, ...params } });

    if (!results.length) return;

    return results[0];
};

export const changeCorrectionState = (id, data) => {
    return axios.post(prefix + `/${id}/change_state/`, data);
};

export const fetchInformation = book => {
    return axios.get(prefix + '/information/', { params: { book } });
};

export const addCorrection = data => {
    return axios.post(prefix + '/', data);
};

export const deleteCorrection = id => {
    return axios.delete(`${prefix}/${id}/`);
};

export const getCorrectionReport = (id, params = {}) => {
    return axios.get(`/api/v2/books/${id}/corrections_report/`, { responseType: 'blob', ...params });
};
